import * as React from "react";
import { IBaseLink } from "~/types/link";
import IconEditorial from "~/components/icon-editorial/icon-editorial";

export interface ISocialLink extends IBaseLink {
    svgCodeSmallIcon?: string;
    svgCodeLargeIcon?: string;
}

const FooterSocial: React.FC<ISocialLink> = props => {
    return (
        <li className="footer-social__item" key={props.url}>
            <a href={props.url} target="_blank" title={props.label}>
                {(props.svgCodeLargeIcon || props.svgCodeSmallIcon) && (
                    <IconEditorial svgCodeLargeIcon={props.svgCodeLargeIcon || props.svgCodeSmallIcon} />
                )}
            </a>
        </li>
    );
};

export default FooterSocial;
